import request from '@/utils/request'

export function getSaleOrderList(data) {
  return request.post('/sale-order/list', data)
}

export function addSaleOrder(data) {
  return request.post('/sale-order/add', data)
}

export function modifySaleOrder(data) {
  return request.post('/sale-order/modify', data)
}

export function deleteSaleOrder(data) {
  return request.post('/sale-order/delete', data)
}

export function confirmSaleOrder(data) {
  return request.post('/sale-order/confirm', data)
}

export function unConfirmSaleOrder(data) {
  return request.post('/sale-order/un-confirm', data)
}



// WEBPACK FOOTER //
// ./src/api/sale/order.js